export const userInfo = state => state.userInfo;
export const balance = state => state.balance;
export const pending = state => state.pending;
export const todayRate = state => state.todayRate;


